import { Box, Typography } from "@mui/material";

/**
 * Rounds a date to the nearest day
 * @param {Date} date
 * @returns Rounded Date
 */
function roundDateDownToNearestDay(date) {
    const roundedDate = new Date(date);
    roundedDate.setHours(0, 0, 0, 0);
    return roundedDate;
}

/**
 * Gets all days between the first and last time
 * @param {Date} firstTime
 * @param {Date} lastTime
 * @returns Array of Dates with days
 */
function getDays(firstTime, lastTime) {
    const days = [];
    let cur = new Date(firstTime);
    while (cur <= lastTime) {
        days.push(cur);
        cur = new Date(roundDateDownToNearestDay(cur));
        cur.setDate(cur.getDate() + 1);
    }
    // console.log(days);
    return days;
}

export default function ScheduleDays({ scheduleStartTime, scheduleEndTime }) {
    return (
        <Box
            id="ScheduleDays"
            sx={{
                minWidth: "5.5em",
                marginRight: "1em",
                position: "relative",
                "@media (max-width: 750px)": {
                    minWidth: "4em",
                },
            }}
        >
            {getDays(scheduleStartTime, scheduleEndTime).map((day) => (
                <Typography
                    key={day.getTime()}
                    sx={{
                        position: "absolute",
                        right: "1em",
                        top: `${
                            ((day - scheduleStartTime) /
                                (scheduleEndTime - scheduleStartTime)) *
                            100
                        }%`,
                        transform: "translateY(-50%)",
                        textAlign: "center",
                        "@media (max-width: 750px)": {
                            transform: "translateY(-50%) rotate(-90deg)",
                        },
                    }}
                >
                    {day.toLocaleDateString("en-US", {
                        month: "short",
                        day: "2-digit",
                    })}
                </Typography>
            ))}
        </Box>
    );
}
